<template>
  <div class="add-client-address-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>{{isClient ? 'Client Address' : 'Examinee Address'}}</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body div-responsive">
              <div class="box-body">
                <div v-if="!isFromClient">
                  <div class="box-row">
                    <div class="box-col box-col-left">Address 1</div>
                    <div class="box-col box-col-right">
                      <input id="address-line1" autocomplete="address-line1"  name="address-line1" class="padding-left-10" maxlength="100" type="text" v-model="addressInfo.address1" placeholder="Address 1" tabindex="1"/>
                      <div v-if="showError && !validateAddress1" class="text-danger pl-2">
                        {{ addressLine1Error }}
                      </div>
                    </div>
                  </div>
                  <div class="box-row">
                    <div class="box-col box-col-left">Address 2</div>
                    <div class="box-col box-col-right">
                      <input id="address-line2" autocomplete="address-line2"  name="address-line2" class="padding-left-10" maxlength="100" type="text" v-model="addressInfo.address2" placeholder="Address 2" tabindex="2" />
                      <div v-if="showError && !validateAddress2" class="text-danger pl-2">
                        {{ addressLine2Error }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">City</div>
                  <div class="box-col box-col-right">
                    <input id="address-level2" autocomplete="address-level2"  name="address-level2" class="padding-left-10" type="text" v-model="addressInfo.city" placeholder="City" tabindex="3"/>
                    <div v-if="showError && !validateCity" class="text-danger pl-2">
                      {{ cityError }}
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">State</div>
                  <div class="box-col box-col-right select-state">
                    <el-input
                      v-if="isInternationalAddress"
                      id="address-level1"
                      autocomplete="address-level1"
                      name="address-level1"
                      class="w-50"
                      type="text"
                      v-model="addressInfo.state"
                      placeholder="State / Province / Region"
                      tabindex="4"
                    />
                    <select v-else name="state" class="textbox" v-model="addressInfo.state" tabindex="4">
                      <option hidden value="">Please choose the State</option>
                      <option v-for="(state, index) in states" :value="state.value" :key="index">{{ state.text }}</option>
                    </select>
                    <div v-if="showError && isInternationalAddress && !validateInternationalState" class="text-danger pl-2">
                      {{ stateError }}
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Postcode</div>
                  <div class="box-col box-col-right">
                    <input id="postcode" autocomplete="postal-code"  name="postcode" class="padding-left-10" v-model="addressInfo.postcode" placeholder="Postcode" tabindex="5"/>
                    <div v-if="showError && !validatePostCode" class="text-danger pl-2">
                      {{ postcodeError }}
                    </div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Country</div>
                  <div class="box-col box-col-right d-flex align-center">
                    <div class="w-30">
                      <el-input
                        v-if="isInternationalAddress"
                        id="country"
                        autocomplete="country"
                        name="country"
                        type="text"
                        v-model="addressInfo.country"
                        placeholder="Country"
                        tabindex="6"
                      />
                      <span v-else>Australia</span>
                      <div v-if="showError && isInternationalAddress && !validateInternationalCountry" class="text-danger pl-2">
                        {{ countryError }}
                      </div>
                    </div>
                    <el-checkbox
                      class="default-checkbox ml-2 international-address-checkbox"
                      v-model="isInternationalAddress"
                      @change="onInternationalAddressChange"
                    >
                      International Address
                    </el-checkbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <button style="min-width: 120px;
    min-height: 39px;
    border-radius: 5px;
    text-transform: capitalize;
    background-color: #525252; color: white" @click="clickSave($event)" dark>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import CitySuggestion from '@/components/CitySuggestion'

  export default {
    name: 'AddClientAddressModal',
    props: ['typrProps', 'clientProps', 'isFromClient'],
    components: {
      CitySuggestion,
    },
    data() {
      return {
        showError: false,
        isClient: false,
        loadModal: false,
        hasError: false,
        clickState: false,
        isInternationalAddress: false,
        singleCase: this.$parent.singleCase,
        listCities: [],
        cities: [],
        citySuggestion: CitySuggestion,
        states: utilities.getStates(),
        addressInfo: utilities.initAddress(),
        isConsentForm: false,
        loaded: false,
      }
    },

    computed: {
      validatePostCode() {
        if (this.isInternationalAddress) {
          return true
        }
        return utilities.validatePostCode(this.addressInfo.postcode)
      },
      validateAddress1() {
        return utilities.validateAddress(this.addressInfo.address1)
      },
      validateAddress2() {
        return utilities.validateAddress(this.addressInfo.address2)
      },
      validateCity(){
        return utilities.validateCity(this.addressInfo.city)
      },
      validateInternationalCountry() {
        if (!this.isInternationalAddress) {
          return true
        }
        return utilities.validateNameText(this.addressInfo.country)
      },
      validateInternationalState() {
        if (!this.isInternationalAddress) {
          return true
        }
        if(this.addressInfo.state.length > 20) {
          return false
        }
        return utilities.validateNameText(this.addressInfo.state)
      },
      validateNewEmail() {
        if (this.singleCase.claimantEmail == '' || !utilities.validateEmail(this.singleCase.claimantEmail)) {
          return false
        }
        return true
      },
      addressLine1Error() {
        if (!this.showError || this.validateAddress1) {
          return ''
        }
        return utilities.getValidateAddressError(this.addressInfo.address1) || ''
      },
      addressLine2Error() {
        if (!this.showError || this.validateAddress2) {
          return ''
        }
        return utilities.getValidateAddressError(this.addressInfo.address2) || ''
      },
      cityError() {
        if (!this.showError || this.validateCity) {
          return ''
        }
        return utilities.getValidateCityError(this.addressInfo.city) || ''
      },
      postcodeError() {
        if (!this.showError || this.validatePostCode) {
          return ''
        }
        return utilities.getValidatePostCodeError(this.addressInfo.postcode) || ''
      },
      countryError() {
        if (!this.showError || !this.isInternationalAddress || this.validateInternationalCountry) {
          return ''
        }
        return utilities.getValidateNameTextError(this.addressInfo.country) || ''
      },
      stateError() {
        if (!this.showError || !this.isInternationalAddress || this.validateInternationalState) {
          return ''
        }
        if(this.addressInfo.state.length > 20) {
          return 'must less than 20 characters'
        }
        return utilities.getValidateNameTextError(this.addressInfo.state) || ''
      },
    },

    methods: {
      isAustraliaCountry(country) {
        const value = (country || '').toString().trim().toLowerCase()
        return value === '' || value === 'australia' || value === 'au'
      },

      onInternationalAddressChange() {
        if (this.isInternationalAddress) {
          if (this.isAustraliaCountry(this.addressInfo.country)) {
            this.addressInfo.country = ''
          }
        } else {
          this.addressInfo.country = 'Australia'
          const matchedState = this.states.find((state) => state.value === this.addressInfo.state)
          if (!matchedState) {
            this.addressInfo.state = ''
          }
        }
      },

      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },

      async clickSave(e) {
        e.preventDefault()
        if(!this.validateAddress1 || !this.validateAddress2 || !this.validateCity || !this.validatePostCode || !this.validateInternationalCountry || !this.validateInternationalState) {
          this.showError = true
          return
        } else {
          this.showError = false
        }
        if (this.typrProps == 'fromBooking') {
          this.saveToBookingAddress()
        } else if (this.typrProps == 'fromclient') {
          this.saveToClientAddress()
        } else if (this.typrProps == 'consentForm') {
          this.saveToFormAddress()
        } else {
          this.saveToCaseAddress()
        }
        // this.handleModal()
      },

      fromConsentForm() {
        this.isConsentForm = true
      },

      setClientAddressDetails() {
        this.addressInfo.address1 = this.clientProps.addressLine1
        this.addressInfo.address2 = this.clientProps.addressLine2
        this.addressInfo.city = this.clientProps.city
        this.addressInfo.state = this.clientProps.state
        this.addressInfo.postcode = this.clientProps.postcode
        this.addressInfo.country = this.clientProps.country || 'Australia'
        this.isInternationalAddress = !this.isAustraliaCountry(this.addressInfo.country)
        if (!this.isInternationalAddress) {
          this.addressInfo.country = 'Australia'
        }
      },

      async saveToClientAddress() {
        if (!this.isInternationalAddress) {
          this.addressInfo.country = 'Australia'
        }
        if (this.clientProps.clientId !== undefined && this.clientProps.clientId != '' && this.clientProps.clientId !== 'new') {
          var params = {
            ClientName: this.clientProps.clientName,
            BranchName: this.clientProps.branchName,
            PrepaymentRequired: this.clientProps.prepaymentRequired,
            PaymentDeferralOption: this.clientProps.paymentDeferralOption,
            RedHealthMayContactClaimants: this.clientProps.redHealthMayContactClaimants,
            BillingCategoryID: this.clientProps.BillingCategoryID,
            AddressLine1: this.addressInfo.address1,
            AddressLine2: this.addressInfo.address2,
            City: this.addressInfo.city,
            State: this.addressInfo.state,
            Postcode: this.addressInfo.postcode,
            Country: this.addressInfo.country,
          }
          if (this.clientProps.clientId !== undefined && this.clientProps.clientId != '') params.ClientID = this.clientProps.clientId
          if (params.AddressLine1 !== '' || params.AddressLine2 !== '') {
            var geoLoc = await utilities.getGeoLocation(params.AddressLine1 + ',' + params.AddressLine2 + ',' + params.City + ',' + params.State + ',' + params.Postcode)
            params.Latitude = geoLoc.lat
            params.Longitude = geoLoc.lng
            if (this.$parent.client.clientId !== undefined && this.$parent.client.clientId !== '') {
              var check = await utilities.putClient(params)
              if (check != false) {
                this.$parent.client.addressLine1 = this.addressInfo.address1
                this.$parent.client.addressLine2 = this.addressInfo.address2
                this.$parent.client.city = this.addressInfo.city
                this.$parent.client.state = this.addressInfo.state
                this.$parent.client.postcode = this.addressInfo.postcode
                this.$parent.client.country = this.addressInfo.country
                this.successMessage = 'Client updated.'
                utilities.showAlert('.alert-success')
              }
            }
            this.handleModal()
          } else {
            {
              var check = await utilities.putClient(params)
              if (check != false) {
                this.$parent.client.addressLine1 = this.addressInfo.address1
                this.$parent.client.addressLine2 = this.addressInfo.address2
                this.$parent.client.city = this.addressInfo.city
                this.$parent.client.state = this.addressInfo.state
                this.$parent.client.postcode = this.addressInfo.postcode
                this.$parent.client.country = this.addressInfo.country
                this.$parent.successMessage = 'Client updated.'
                utilities.showAlert('.alert-success')
              }
            }
            this.handleModal()
          }
        } else {
          this.$parent.client.addressLine1 = this.addressInfo.address1
          this.$parent.client.addressLine2 = this.addressInfo.address2
          this.$parent.client.city = this.addressInfo.city
          this.$parent.client.state = this.addressInfo.state
          this.$parent.client.postcode = this.addressInfo.postcode
          this.$parent.client.country = this.addressInfo.country
          this.handleModal()
        }
        this.$parent.addressKey += 1
      },

      setCaseAddressDetails() {
        this.addressInfo.address1 = this.singleCase.ClaimantAddressLine1
        this.addressInfo.address2 = this.singleCase.ClaimantAddressLine2
        this.addressInfo.city = this.singleCase.ClaimantCity
        this.addressInfo.state = this.singleCase.ClaimantState
        this.addressInfo.postcode = this.singleCase.ClaimantPostcode
      },

      setCaseAddressDetailsLowerCase() {
        this.addressInfo.address1 = this.singleCase.claimantAddressLine1
        this.addressInfo.address2 = this.singleCase.claimantAddressLine2
        this.addressInfo.city = this.singleCase.claimantCity
        this.addressInfo.state = this.singleCase.claimantState
        this.addressInfo.postcode = this.singleCase.claimantPostcode
      },


      saveToCaseAddress() {
        this.singleCase.ClaimantAddressLine1 = this.addressInfo.address1
        this.singleCase.ClaimantAddressLine2 = this.addressInfo.address2
        this.singleCase.ClaimantCity = this.addressInfo.city
        this.singleCase.ClaimantState = this.addressInfo.state
        this.singleCase.ClaimantPostcode = this.addressInfo.postcode
        this.$emit('changedAddress', this.singleCase)
        this.$parent.isEditAddress = true
        this.$forceUpdate()
        if (this.addressInfo.address1 == '' && this.addressInfo.address2 == '' && this.addressInfo.city == '' && this.addressInfo.state == '' && this.addressInfo.postcode == '') {
          this.$parent.isEditAddress = false
        }
        this.$parent.addressKey += 1
        if (this.isConsentForm) {
          this.$parent.tapUpdate()
        }
        this.handleModal()
      },

      saveToFormAddress() {
        this.$parent.singleCase.claimantAddressLine1 = this.addressInfo.address1
        this.$parent.singleCase.claimantAddressLine2 = this.addressInfo.address2
        this.$parent.singleCase.claimantCity = this.addressInfo.city
        this.$parent.singleCase.claimantState = this.addressInfo.state
        this.$parent.singleCase.claimantPostcode = this.addressInfo.postcode
        this.$parent.singleCase.claimantFullAddress = utilities.addComma(this.addressInfo.address1) + utilities.addComma(this.addressInfo.address2) + utilities.addComma(this.addressInfo.city) + utilities.addComma(this.addressInfo.state) + this.addressInfo.postcode
        this.$emit('changedAddress', this.singleCase)
        this.$parent.isEditAddress = true
        this.$forceUpdate()
        if (this.addressInfo.address1 == '' && this.addressInfo.address2 == '' && this.addressInfo.city == '' && this.addressInfo.state == '' && this.addressInfo.postcode == '') {
          this.$parent.isEditAddress = false
        }
        this.$parent.addressKey += 1
        if (this.isConsentForm) {
          this.$parent.tapUpdate()
        }
        this.handleModal()
      },

      setBookingAddressDetails() {
        this.addressInfo.address1 = this.booking.claimantAddressLine1
        this.addressInfo.address2 = this.booking.claimantAddressLine2
        this.addressInfo.city = this.booking.claimantCity
        this.addressInfo.state = this.booking.claimantState
        this.addressInfo.postcode = this.booking.claimantPostcode
      },

      saveToBookingAddress() {
        this.booking.claimantAddressLine1 = this.addressInfo.address1
        this.booking.claimantAddressLine2 = this.addressInfo.address2
        this.booking.claimantCity = this.addressInfo.city
        this.booking.claimantState = this.addressInfo.state
        this.booking.claimantPostcode = this.addressInfo.postcode
        const country = this.isInternationalAddress ? this.addressInfo.country : 'Australia'
        this.booking.claimantFullAddress =
          utilities.convertNullToEmpty(this.booking.claimantAddressLine1) +
          ' ' +
          utilities.convertNullToEmpty(this.booking.claimantAddressLine2) +
          ' ' +
          utilities.convertNullToEmpty(this.booking.claimantCity) +
          ' ' +
          utilities.convertNullToEmpty(this.booking.claimantState) +
          ' ' +
          utilities.convertNullToEmpty(this.booking.claimantPostcode) +
          ' ' +
          utilities.convertNullToEmpty(country)

        this.$parent.booking = this.booking
        this.$parent.addressKey += 1
        this.$parent.isEditAddress = true
        if (this.addressInfo.address1 == '' && this.addressInfo.address2 == '' && this.addressInfo.city == '' && this.addressInfo.postcode == '') {
          this.$parent.isEditAddress = false
        }
        this.handleModal()
      },

      handleState() {
        this.clickState = true
      },
    },

    beforeMount() {
    },

    mounted() {
      setTimeout(() => {
        $('.vue-suggestion input.city-suggestion').each((index, element) => {
          $(element).focusout(() => {
            this.$refs['citySuggestion' + index][0].searchText = ''
          })
        })
      }, 500)
    },

    updated() {
      if (!this.loaded) {
        if (this.typrProps == 'fromclient') {
          this.setClientAddressDetails()
        }
        this.loaded = true
      }
    },
  }
</script>

<style scoped>
.international-address-checkbox {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-left: 0;
}
</style>
